var _path, _ellipse, _path2, _path3, _ellipse2, _path4, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsSolution3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0217 43.6528H18.6895V55.7437H18.7061C18.7061 59.0104 27.5072 61.6586 38.3639 61.6586C49.2206 61.6586 58.0217 59.0104 58.0217 55.7437C58.0217 55.7425 58.0217 55.7412 58.0217 55.74V43.6528Z",
    fill: "url(#paint0_linear_2137_19330)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3629,
    cy: 43.9148,
    rx: 19.6578,
    ry: 5.91484,
    fill: "url(#paint1_linear_2137_19330)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0217 31.7319H18.6895V43.8228H18.7061C18.7061 47.0895 27.5072 49.7377 38.3639 49.7377C49.2206 49.7377 58.0217 47.0895 58.0217 43.8228C58.0217 43.8216 58.0217 43.8203 58.0217 43.8191V31.7319Z",
    fill: "#FF984F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0217 31.7319H18.6895V43.8228H18.7061C18.7061 47.0895 27.5072 49.7377 38.3639 49.7377C49.2206 49.7377 58.0217 47.0895 58.0217 43.8228C58.0217 43.8216 58.0217 43.8203 58.0217 43.8191V31.7319Z",
    fill: "url(#paint2_linear_2137_19330)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3629,
    cy: 31.9939,
    rx: 19.6578,
    ry: 5.91484,
    fill: "#FFA930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0217 19.9028H18.6895V31.9937H18.7061C18.7061 35.2604 27.5072 37.9086 38.3639 37.9086C49.2206 37.9086 58.0217 35.2604 58.0217 31.9937C58.0217 31.9925 58.0217 31.9912 58.0217 31.99V19.9028Z",
    fill: "url(#paint3_linear_2137_19330)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3629,
    cy: 20.1644,
    rx: 19.6578,
    ry: 5.91484,
    fill: "url(#paint4_linear_2137_19330)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3649,
    cy: 19.9029,
    rx: 3.29067,
    ry: 1.58258,
    fill: "#D9D9D9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3649,
    cy: 19.9029,
    rx: 3.29067,
    ry: 1.58258,
    fill: "url(#paint5_linear_2137_19330)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.3649,
    cy: 19.9029,
    rx: 3.29067,
    ry: 1.58258,
    fill: "url(#paint6_linear_2137_19330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19330",
    x1: 43.4868,
    y1: 49.7382,
    x2: 15.0972,
    y2: 49.7382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19330",
    x1: 18.7051,
    y1: 43.9148,
    x2: 58.0206,
    y2: 43.9148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB44B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19330",
    x1: 43.4868,
    y1: 37.8173,
    x2: 15.0972,
    y2: 37.8173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB7B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19330",
    x1: 43.4868,
    y1: 25.9882,
    x2: 15.0972,
    y2: 25.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19330",
    x1: 38.3629,
    y1: 14.2495,
    x2: 38.3629,
    y2: 26.0792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF984F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2137_19330",
    x1: 38.3649,
    y1: 18.3203,
    x2: 38.3649,
    y2: 21.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2137_19330",
    x1: 39.2235,
    y1: 19.39,
    x2: 34.4731,
    y2: 19.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSolution3);
export default __webpack_public_path__ + "static/media/awsSolution3.5acee87b875550c42515b5d44b74186e.svg";
export { ForwardRef as ReactComponent };